import { ScrollTriggerClass } from './'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

class OpeningAnimation {
  constructor(el) {
    this.dom = {el: el};
    // this.dom.plant = this.dom.el.querySelector('[data-js="opening-plant"]');
    this.dom.man = this.dom.el.querySelector('[data-js="opening-man"]');
    this.dom.woman = this.dom.el.querySelector('[data-js="opening-woman"]');

    this.dom.balloon = this.dom.el.querySelectorAll('[data-js="opening-balloon"]');
    this.dom.balloon01 = this.dom.el.querySelectorAll('[data-js="opening-balloon-01"]');
    this.dom.balloon02 = this.dom.el.querySelectorAll('[data-js="opening-balloon-02"]');
    this.dom.balloon03 = this.dom.el.querySelectorAll('[data-js="opening-balloon-03"]');

    this.dom.copy = this.dom.el.querySelectorAll('[data-js="opening-copy"]');

    this.dom.triggerClass = document.querySelectorAll('[data-trigger="stc"]');
    
    this.init();
  }
  
  init() {
    setTimeout(()=>{
      window.scroll({top: 0, behavior: 'instant'});
    }, 100)
    this.openingStart();
    // this.textFadeAnimation();
    // this.scrollDisable(30);
  }

  openingStart() {
    this.dom.el.dataset.opening = 'start';

    const tl = gsap.timeline();
    // tl.to(this.dom.plant, {
    //   scale: 1,
    //   opacity: 1,
    //   ease: 'power1.inOut',
    //   duration: 1.2,
    //   // delay: .1,
    // });
    tl.to(this.dom.man, {
      opacity: 1,
      translateY: 0,
      ease: 'power2.inOut',
      duration: 1.2,
    }, '-=.6');
    tl.to(this.dom.woman, {
      opacity: 1,
      translateY: 0,
      ease: 'power2.inOut',
      duration: 1.2,
    }, '-=.9');
    
    [...this.dom.balloon].forEach(el => {
      tl.to(el, {
        opacity: 1,
        translateY: 0,
        ease: 'power2.inOut',
        duration: 1.2,
      }, '-=1.1')
    });
    [...this.dom.balloon01].forEach(el => {
      tl.to(el, {
        opacity: 1,
        translateY: 0,
        ease: 'power2.inOut',
        duration: 1.2,
      }, '-=1.1')
    });
    [...this.dom.balloon02].forEach(el => {
      tl.to(el, {
        opacity: 1,
        translateY: 0,
        ease: 'power2.inOut',
        duration: 1.2,
      }, '-=1.1')
    });
    [...this.dom.balloon03].forEach(el => {
      tl.to(el, {
        opacity: 1,
        translateY: 0,
        ease: 'power2.inOut',
        duration: 1.2,
      }, '-=1.1')
    });

    [...this.dom.copy].forEach(el => {
      tl.to(el, {
        opacity: 1,
        translateY: 0,
        ease: 'power1.inOut',
        duration: 1.2,
        delay: .3,
      }, '-=1.3')
    });
  }

  scrollDisable(_time) {
    setTimeout(()=>{
      document.body.dataset.isScrolldisable = 'true';
    }, _time);
  }

  // openingStart() {
  //   // setTimeout(()=>{
  //   // }, _time);
  //   this.dom.el.dataset.opening = 'start';

  //   if (this.getWindowW() < 768) {
  //     gsap.to(this.dom.el, {
  //       height: 240,
  //       ease: 'expo.inOut',
  //       duration: 2.5,
  //       // delay: .1,
  //       onStart: ()=>{},
  //     })
  //     gsap.to(this.dom.copy, {
  //       translateY: '37.5%',
  //       ease: 'expo.inOut',
  //       duration: 2.5,
  //       // delay: .1,
  //       onStart: ()=>{},
  //     })
  //     gsap.to(this.dom.cover, {
  //       // '--mask-start': ((240 / this.getWindowH()) * 100),
  //       // '--mask-end': ((240 / this.getWindowH()) * 100),
  //       '--mask-start': 90,
  //       '--mask-end': 100,
  //       height: 240,
  //       ease: 'expo.inOut',
  //       duration: 3.4,
  //       // delay: .3,
  //       onStart: ()=>{},
  //     }, '<-12.5%')
  //   } else {
  //     gsap.to(this.dom.copyCover, {
  //       '--mask-start': 19.8279648609,
  //       '--mask-end': 22.3279648609,
  //       ease: 'power2.inOut',
  //       duration: 2,
  //       delay: .6,
  //       onStart: ()=>{},
  //     })
  //     gsap.to(this.dom.copyInner, {
  //       width: '22.3279648609%',
  //       ease: 'power3.inOut',
  //       duration: 2.6,
  //       onStart: ()=>{},
  //     }, '<-12.5%')
  //   }

  //   this.triggerEvent();
  // }

  triggerEvent() {
    if (this.dom.triggerClass) new ScrollTriggerClass(this.dom.triggerClass);
  }

  getWindowW() {
    return window.innerWidth;
  }

  getWindowH() {
    return window.outerHeight;
  }
}

export default OpeningAnimation